import { render, staticRenderFns } from "./notesPerso.vue?vue&type=template&id=87bc0aae&"
import script from "./notesPerso.vue?vue&type=script&lang=js&"
export * from "./notesPerso.vue?vue&type=script&lang=js&"
import style0 from "./notesPerso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports